
import React from 'react';
import GasKpiDashboard from '@/components/gas/dashboard/GasKpiDashboard';
import CompactLayout from '@/components/layout/CompactLayout';
import { Toaster } from '@/components/ui/toaster';

const GasKpiDashboardPage = () => {
  return (
    <CompactLayout>
      <div className="h-[calc(100vh-4rem)] overflow-hidden">
        <GasKpiDashboard />
      </div>
      <Toaster />
    </CompactLayout>
  );
};

export default GasKpiDashboardPage;
